app.directive('slideUpOnScroll', function($window, $document, throttle) {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
            $element.addClass('sg-slide-up-on-scroll');
            var threshold = parseInt($attrs.slideUpOnScroll, 10) || 100;

            var jWindow = angular.element($window);
            var previousStaticScrollY = jWindow.scrollTop();

            jWindow.on('scroll', throttle(50, function($event) {
                var currentScrollY = jWindow.scrollTop();
                var scrollYDelta = previousStaticScrollY - currentScrollY;

                if (scrollYDelta >= threshold) {
                    previousStaticScrollY = currentScrollY;
                    $element.removeClass('sg-state-slide-up');
                } else if (scrollYDelta <= (threshold * -1)) {
                    previousStaticScrollY = currentScrollY;
                    $element.addClass('sg-state-slide-up');
                }
            }));
        }
    };
});
